<template>
  <div class="legal wide-container">
    <h1 class="legal__title">
      <Lang by-key="change-and-refund-title" />
    </h1>

    <h2 class="legal__subtitle">
      <Lang by-key="change-and-refund-subtitle-0" />
    </h2>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="change-and-refund-0-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="change-and-refund-0-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="change-and-refund-1-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="change-and-refund-1-body-0" />
      </p>

      <ul class="legal__block__list">
        <li><Lang by-key="change-and-refund-1-body-1" /></li>
        <li><Lang by-key="change-and-refund-1-body-2" /></li>
        <li><Lang by-key="change-and-refund-1-body-3" /></li>
      </ul>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="change-and-refund-2-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="change-and-refund-2-body-0" />
      </p>

      <ul class="legal__block__list">
        <li><Lang by-key="change-and-refund-2-body-1" /></li>
        <li><Lang by-key="change-and-refund-2-body-2" /></li>
        <li><Lang by-key="change-and-refund-2-body-3" /></li>
        <li><Lang by-key="change-and-refund-2-body-4" /></li>
      </ul>
    </div>

    <h2 class="legal__subtitle">
      <Lang by-key="change-and-refund-subtitle-1" />
    </h2>

    <div class="legal__block">
      <p class="legal__block__body">
        <Lang by-key="change-and-refund-3-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="change-and-refund-3-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="change-and-refund-3-body-2" />
      </p>
    </div>

    <div class="legal__btns">
      <SplNuxtLink
        :to="manageVoucherLoginURL"
        no-lang
        is-external
      >
        <SplButton
          variant="primary"
          size="lg"
        >
          <Lang by-key="change-and-refund-go-to-form" />
        </SplButton>
      </SplNuxtLink>
    </div>
  </div>
</template>

<script lang="ts">
import SplNuxtLink from '~/core/components/shared/SplNuxtLink.vue'
import SplButton from '~/core/components/shared/form/SplButton.vue'

import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'

import { translate } from '~/core/ts/util/translate'

definePageMeta({
  layout: 'checkout',
})

export default defineNuxtComponent({
  components: {
    SplNuxtLink,
    SplButton,
  },
  setup() {
    const runtime = useRuntimeConfig()
    const manageVoucherLoginURL = runtime.public.urls.static.manageVoucherLogin

    const builder = HeadMetaBuilder.create()

    const title = translate({
      es: 'Política de cambios y devoluciones',
      pt: 'Política de devoluções e trocas',
    })

    builder.withTitleAndMetaTitle(`${title} | Spalopia.com`)

    useHead(builder.get())

    return {
      manageVoucherLoginURL,
    }
  }
})
</script>

<style lang="scss" scoped>
@import url('./legal.scss');
</style>
